"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyIsoCodePattern = exports.countryIsoCodePattern = exports.otpProviders = void 0;
exports.otpProviders = ['2FACTOR', 'AFRO', 'TWILIO'];
exports.countryIsoCodePattern = '^[A-Z]{2}$';
exports.currencyIsoCodePattern = '^[A-Z]{3}$';
//# sourceMappingURL=Org.js.map